import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {
  AccM2StrediskoGetCentresApiResponseMetadaAccounting,
  GetOperationalItemsResponseMetadaAccounting,
} from '../types';

const getOperationItemsResponseMock: GetOperationalItemsResponseMetadaAccounting[] = [
  {
    applicationId: 'workshop',
    itemCodeName: 'Material Work Item Group',
    itemCode: 'MAT001',
    operationId: 'test-work-item-group-id',
    itemGroup: 'material',
    isGroupDefault: true,
  },
  {
    applicationId: 'workshop',
    itemCodeName: 'Service Work Item Group',
    itemCode: 'SRV001',
    operationId: 'service-work-item-group-id',
    itemGroup: 'service',
    isGroupDefault: false,
  },
];

const getAccM2CentresResponseMock: AccM2StrediskoGetCentresApiResponseMetadaAccounting = {
  m2centres: [
    {
      name: 'M2 Centre 1',
      code: 'M2001',
    },
    {
      name: 'M2 Centre 2',
      code: 'M2002',
    },
  ],
};

const getOperationItemsResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/accounting/v1/operation-items', ({request}) => {
      const url = new URL(request.url);
      const application = url.searchParams.get('application');
      const itemGroup = url.searchParams.get('itemGroup');

      // Filter based on query parameters
      const filteredItems = getOperationItemsResponseMock.filter((item) => {
        if (application && item.applicationId !== application) {
          return false;
        }
        if (itemGroup && item.itemGroup !== itemGroup) {
          return false;
        }
        return true;
      });

      return HttpResponse.json(filteredItems);
    })
  );

export const metadaAccountingApiMock = {
  getAccM2CentresResponseMock,
  getOperationItemsResponseMock,
  getOperationItemsResponseInterceptor,
};
